import clsx from "clsx";

import styles from "./Icon.module.scss";
import { IconMap } from "./IconMap";

export interface IconProps {
  iconName: keyof typeof IconMap;
  width?: string;
  color?: string;
  height?: string;
  hover?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const Icon = ({
  iconName,
  width,
  height,
  color,
  hover,
  className,
  style,
}: IconProps) => {
  const IconComponent = IconMap[iconName];

  if (!IconComponent) {
    return null;
  }

  return (
    <IconComponent
      className={clsx(className, {
        [styles.hover]: hover,
        [styles.color]: color,
      })}
      width={width ?? "1.25rem"}
      height={height ?? "1.25rem"}
      style={{ "--icon-color": color, ...style } as React.CSSProperties}
    />
  );
};
